export default function(array) {
    let range = {};
    let minValue = array[0];
    let maxValue = array[array.length - 1];
    range['min'] = minValue;
    range['max'] = maxValue;
    let diffBetweenMinMax = array[array.length - 1] - array[0];
    array.forEach(value => {
        // If the min and max are the same, just set 0 and 100% to the same
        if (diffBetweenMinMax == 0) {
            return;
        }
        if (value - minValue <= 0) {
            return;
        }

        let relativePercent = (value - minValue) / diffBetweenMinMax;
        if (relativePercent <= 0) {
            range['min'] = value;
            return;
        }
        if (relativePercent >= 1) {
            range['max'] = value;
            return;
        }

        range[Math.round((relativePercent * 100), 2) + '%'] = value;
    });

    return range;
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/convert-array-into-no-ui-slider-range.js